"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWordNotExists = exports.ExtendedWordSchema = void 0;
const zod_1 = require("zod");
exports.ExtendedWordSchema = zod_1.z.object({
    gender: zod_1.z.string().optional(),
    id: zod_1.z.string(),
    ipa_txt: zod_1.z.string().optional(),
    known_txt: zod_1.z.string(),
    learn_txt: zod_1.z.string(),
    reading: zod_1.z.string().optional(),
    word_type: zod_1.z.string().optional(),
});
const WordNotExistsSchema = zod_1.z
    .object({
    wordNotExists: zod_1.z.boolean().refine((val) => val === true),
})
    .strict();
// Don't want to use the verbose function here as this is not as much for
// validation as it is for deciding on which case we are.
const isWordNotExists = (x) => WordNotExistsSchema.safeParse(x).success;
exports.isWordNotExists = isWordNotExists;
//# sourceMappingURL=dictionary_word_types.js.map